<template>
	<div class="class" v-katex:auto>
		<teacherHeader :logo_name="logo_name" @info-event="myInfoEvent" @public-event="publicEvent"></teacherHeader>
		<div class="task_cont bg_blue">
			<div class="task_cont_div bg_white radius8 bs">
				<div class="task_cont_nav f18px cl_dark">
					<router-link :to="item.url" class="task_cont_nav_list" v-for="(item,index) in nav" :key="index" :class="{'on': item.id == nav_cur}">{{item.name}}</router-link>
				</div>
				<div class="task_subject cl_gray tc">
					<span class="task_subject_list bg_gray cur" v-for="(item,index) in subject" :key="index"
					 @click="subjectCheck(index)" :class="{'on': subject_cur == item.subjectId}">{{item.subjectName}}</span>
				</div>
				<div class="task_video">
					<div class="task_video_l">
						<div class="famous_screen_list select-wrap" v-if="tab_active==1">
							<el-select v-model="material_cur" placeholder="全部" @change="materialSelect">
								<el-option v-for="item in material" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
							</el-select>
						</div>
							<div class="tab-wrap">
							<div :class="['tab-item',tab_active==0 ? 'active':'']" @click="onChangeTab(0)">知识点</div>
								<div :class="['tab-item',tab_active==1 ? 'active':'']" @click="onChangeTab(1)">章节</div>
						</div>
						<div class="task_video_nav radius8 mat20 cl_dark" v-if="tab_active==1&&chapter.length > 0">
							<div class="task_nav_first mab20" v-for="(item,index) in chapter" :key="index">
								<div class="task_nav_first_title f16px cur" @click="firstOpen(index)" :class="{'on':item.open}">
									<img src="../../../static/select_right.png" class="mar5" />
									<span>{{item.gradeName}}</span>
								</div>
								<div class="task_nav_second mat10" v-for="(second,secondIndex) in item.chapter_data" :key="secondIndex" v-if="item.open">
									<div class="task_nav_second_title cur" @click="secondOpen(index,secondIndex)" :class="{'on':second.open}" :title="second.chapter">
										<img src="../../../static/select_right.png" class="mar5" />
										<span class="clip">{{second.chapter}}</span>
									</div>
									<div class="task_nav_three" v-if="second.open">
										<div class="task_nav_three_title clip mat10 cur" v-for="(three,index) in second.section_knowledge_data" :key="index"
										 :class="{'on':three.knowledgeId == chapter_cur}" @click="knowledgeCheck(three.knowledgeId)"
										 :title="three.knowledgeName">{{three.knowledgeName}}</div>
									</div>
								</div>
							</div>
						</div>
						<div class="task_video_nav radius8 mat20 cl_dark" v-else-if="tab_active==0&&chapter.length > 0">
							<div class="task_nav_first mab20" v-for="(item,index) in chapter" :key="index">
								<div class="task_nav_first_title f16px cur" @click="firstOpen(index)" :class="{'on':item.open}">
									<img src="../../../static/select_right.png" class="mar5" />
									<span>{{item.knowledgeName}}</span>
								</div>
								<div class="task_nav_second mat10" v-for="(second,secondIndex) in item.knowledge_level_two_data" :key="secondIndex" v-if="item.open">
									<div class="task_nav_second_title cur" @click="secondOpen2(index,secondIndex)" :class="{'on':second.open}" :title="second.knowledgeName">
										<img src="../../../static/select_right.png" class="mar5" />
										<span class="clip">{{second.knowledgeName}}</span>
									</div>
									<div class="task_nav_three" v-if="second.open">
										<div class="task_nav_three_title clip mat10 cur" v-for="(three,index) in second.knowledge_level_three_data" :key="index"
										 :class="{'on':three.knowledge_basic_id == chapter_cur}" @click="knowledgeCheck(three.knowledge_basic_id)"
										 :title="three.knowledgeName">{{three.knowledgeName}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="task_video_r" v-if="chapter_cur != '' && chapter_cur != null">
						<div class="task_video_screen">
							<div class="test_screen cl_gray">
								<div class="test_screen_l f16px"><span class="inline">题型</span><i class="inline">：</i></div>
								<div class="test_screen_r tc">
									<span class="test_screen_list bg_gray" v-for="(item,index) in paper_type" :key="index" :class="{'on':item.id==paper_type_cur}"
									 @click="paperTypeCheck(item.id)">{{item.name}}</span>
								</div>
							</div>
							<div class="test_screen cl_gray">
								<div class="test_screen_l f16px"><span class="inline">题类</span><i class="inline">：</i></div>
								<div class="test_screen_r tc">
									<span class="test_screen_list bg_gray" v-for="(item,index) in qtype" :key="index" :class="{'on':item==qtype_cur}"
									 @click="qtypeCheck(item)">{{item}}</span>
								</div>
							</div>
						</div>
						<div class="task_topic_select_cont mat30">
							<div class="famous_screen_list flex mar15">
								<span class="cl_gray f18px">其&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;他：</span>
								<el-select v-model="diff_cur" placeholder="全部难度" clearable @change="diffSelect">
									<el-option v-for="(item,index) in diff" :key="index" :label="item.name":value="item.id"></el-option>
								</el-select>
							</div>
							<div class="famous_screen_list flex mal15">
								<span class="cl_gray f18px"></span>
								<el-select v-model="year_cur" placeholder="全部年份" clearable @change="yearSelect">
									<el-option v-for="(item,index) in year" :key="index" :label="item":value="item"></el-option>
								</el-select>
							</div>
						</div>
						<div class="f18px cl_gray mat30">共 <span class="cl_yel">{{total}}</span> 道题</div>
						<div class="task_video_cont mat20" v-if="list.length > 0">
							<div class="paper_list radius8 bs mab30" v-for="(item,index) in list" :key="index">
								<div class="paper_list_title f18px cl_dark">
									<div class="paper_list_title_l">{{index + 1}}、</div>
									<div class="paper_list_title_r" v-html="item.title"></div>
								</div>
								<div class="paper_list_check f16px cl_gray mat20" v-if="item.qtpye == '单选题' || item.qtpye == '多选题' || item.qtpye == '双选题' || item.qtpye == '选择题'">
									<div class="paper_list_check_list mat10" v-if="item.option_a != ''">
										<div class="paper_list_check_list_l">A、</div>
										<div class="paper_list_check_list_r" v-html="item.option_a"></div>
									</div>
									<div class="paper_list_check_list mat10" v-if="item.option_b != ''">
										<div class="paper_list_check_list_l">B、</div>
										<div class="paper_list_check_list_r" v-html="item.option_b"></div>
									</div>
									<div class="paper_list_check_list mat10" v-if="item.option_c != ''">
										<div class="paper_list_check_list_l">C、</div>
										<div class="paper_list_check_list_r" v-html="item.option_c"></div>
									</div>
									<div class="paper_list_check_list mat10" v-if="item.option_d != ''">
										<div class="paper_list_check_list_l">D、</div>
										<div class="paper_list_check_list_r" v-html="item.option_d"></div>
									</div>
									<div class="paper_list_check_list mat10" v-if="item.option_e != ''">
										<div class="paper_list_check_list_l">E、</div>
										<div class="paper_list_check_list_r" v-html="item.option_e"></div>
									</div>
								</div>
								<div class="" v-else>
									<div class="paper_list_check f16px cl_gray mat20" v-if="item.isSub == 1">
										<div class="paper_list_check_list mat10" v-for="(second,index) in item.subquestions" :key="index" :id="second.id">
											<div class="paper_list_check_list_l">{{index + 1}}、</div>
											<div class="paper_list_check_list_r" v-html="second.title"></div>
										</div>
									</div>
								</div>
								<div class="paper_list_btm flex">
									<p class="f16px cl_dark">难度：
										<span class="cl_yel" v-if="item.diff == 1">非常简单</span>
										<span class="cl_yel" v-if="item.diff == 2">简单</span>
										<span class="cl_yel" v-if="item.diff == 3">一般</span>
										<span class="cl_yel" v-if="item.diff == 4">难</span>
										<span class="cl_yel" v-if="item.diff == 5">非常难</span>
									</p>
									<div class="task_video_list_item_btn cur tc cl_white on" v-if="item.is_join == 1" @click="remove(index)">-移出试题篮</div>
									<div class="task_video_list_item_btn cur tc cl_white" v-else @click="join(index)">+加入试题篮</div>
								</div>
								<div class="paper_list_analysis cl_dark" :class="{'on': item.select}">
									<div class="paper_list_analysis_item">
										<div class="f18px">答案：</div>
										<div class="f16px paper_list_analysis_item_r" v-html="item.answer2"></div>
									</div>
									<div class="paper_list_analysis_item mat10">
										<div class="f18px">解析：</div>
										<div class="f16px paper_list_analysis_item_r" v-html="item.parse"></div>
									</div>
								</div>
								<div class="paper_list_select tc cl_violet cur" :class="{'on': item.select}" @click="select(index)">
									<p>{{item.select ? '收起' : '展开'}}解析</p>
									<img src="../../../static/select_violet.png" class="bg_white radius" />
								</div>
							</div>
						</div>
						<div class="famous_page flex" v-if="list.length > 0">
							<div class="famous_page_l f16px cl_gray"> </div>
							<div class="famous_page_r cl_dark">
								<el-pagination background layout="prev, pager, next, jumper"
								@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
							</div>
						</div>
						<div class="choice_empty tc f18px cl_gray"  v-if="list.length == 0&&loading">
							<p>加载中。。。</p>
						</div>
						<div class="choice_empty tc f18px cl_gray" v-if="list.length == 0&&!loading">
							<p>找不到内容，请重新选择。</p>
						</div>
					</div>
					<div class="task_video_r" v-else>
						<div class="choice_empty tc f18px cl_gray" v-if="tab_active==1&&list.length == 0">
							<p>请先选择章节列表。</p>
						</div>
						<div class="choice_empty tc f18px cl_gray" v-if="tab_active==0&&list.length == 0">
							<p>找不到内容，请重新选择。</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 试题篮 -->
		<router-link :to="{ path: '/organize_details', query: { id: subject_cur }}" class="topic_basket cl_white">
			<img src="../../../static/basket_icon.png" />
			<div class="">
				<p class="f20px">{{subject_name}}</p>
				<p class="f16px mat5">试题篮 <span class="cl_yel">{{JSON.stringify(basket) == '{}' ? '0' : basket.question_num}}</span></p>
			</div>
		</router-link>
	</div>
</template>

<script>
	import teacherHeader from '../../components/teacher_header.vue'
	
	export default {
		name: 'organize',
		components: {
			teacherHeader,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				nav: [
					{
						id: 1,
						name: "视频作业",
						url: "/task_video",
					},{
						id: 2,
						name: "试卷作业",
						url: "/task_paper",
					},{
						id: 3,
						name: "习题作业",
						url: "/task_topic",
					},
				],
				nav_cur: 3,
				logo_name: "学科作业资源库",
				subject: [], //学科
				subject_cur: "",
				subject_name: "",
				material: [], //教材
				material_cur: "",
				chapter: [], //章节
				chapter_cur: "",
				paper_type: [], //试题类型
				paper_type_cur: "",
				qtype: [], //题型
				qtype_cur: "",
				diff: [
					{
						id: 1,
						name: "非常简单",
					},{
						id: 2,
						name: "简单",
					},{
						id: 3,
						name: "一般",
					},{
						id: 4,
						name: "难",
					},{
						id: 5,
						name: "非常难",
					},
				], //难度
				diff_cur: "",
				year: [], //年份
				year_cur: "",
				list: [],
				currentPage: 1, //当前页数
				pageSize: 20, //每页数量
				total: 0, //总页数
				basket: {},
				loading:false,
				tab_active:0,//0知识点，1章节
			}
		},
		created() {
			
		},
		mounted() {
			this.getSubject();
			this.getPaperTpye();
			this.getDate();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//学科
			getSubject () {
				this.$get("/api/material/get_subject_data",{})
				.then(res => {
					this.subject = res.data;
					this.subject_cur = this.subject[0].subjectId;
					this.subject_name = this.subject[0].subjectName;
					this.getSubjectQtype();
					this.getMaterial();
					this.getBasket();
				});
			},
			subjectCheck (e) {
				this.subject_cur = this.subject[e].subjectId;
				this.subject_name = this.subject[e].subjectName;
				this.getSubjectQtype();
				this.getMaterial();
				this.getBasket();
			},
			//试题类型
			getPaperTpye () {
				this.$get("/api/teacher/get_paper_tpye_data",{})
				.then(res => {
					this.paper_type = res.data;
					this.paper_type.unshift({id: "", name: "全部"});
					this.paper_type_cur = this.paper_type[0].id;
				});
			},
			paperTypeCheck (e) {
				this.paper_type_cur = e;
				this.currentPage = 1;
				this.getList();
			},
			//题型
			getSubjectQtype () {
				this.$get("/api/teacher/get_subject_qtype_data",{
					subject_id: this.subject_cur,
				})
				.then(res => {
					this.qtype = res.data;
					this.qtype.unshift("全部");
					this.qtype_cur = this.qtype[0];
				});
			},
			qtypeCheck (e) {
				this.qtype_cur = e;
				this.currentPage = 1;
				this.getList();
			},
			diffSelect () {
				this.currentPage = 1;
				this.getList();
			},
			//年份
			getDate () {
				var year = new Date().getFullYear();
				for (let i = 0; i < 5; i++ ) {
					this.year.push(year-(3-i))
				}
			},
			yearSelect () {
				this.currentPage = 1;
				this.getList();
			},
			//教材
			getMaterial () {
				this.$get("/api/teacher/get_subject_chapter_edition_data",{
					token: localStorage.getItem("token"),
					subject_id: this.subject_cur,
				})
				.then(res => {
					this.material = res.data;
					this.material_cur = this.material[0].Id;
					
					this.tab_active ? this.getChapter() : this.getKnowLedge();
				
				});
			},
			//根据学科获取3级分类数据
			getKnowLedge(){
					this.$get("/api/teacher/get_knowledge_data",{
					token: localStorage.getItem("token"),
					subject_id: this.subject_cur,
				})
				.then(res => {
					this.loading=false;
					this.chapter = [];
					this.chapter_cur = "";
					if (res.data.length > 0) {
						for (let i = 0; i < res.data.length; i++) {
							res.data[i].open = false;
							if (res.data[i].knowledge_level_two_data.length > 0) {
								for (let j = 0; j < res.data[i].knowledge_level_two_data.length; j++) {
									res.data[i].knowledge_level_two_data[j].open = false;
								}
							}
						}
						this.chapter = res.data;
						res.data[0].open = true;
						if (res.data[0].knowledge_level_two_data.length > 0) {
							res.data[0].knowledge_level_two_data[0].open = true;
							if (this.chapter[0].knowledge_level_two_data[0].knowledge_level_three_data.length > 0) {
								this.chapter_cur = this.chapter[0].knowledge_level_two_data[0].knowledge_level_three_data[0].knowledge_basic_id;
							}
						}
						if (this.chapter_cur != "") {
							this.getList();
						}
					}
				});
			},
			materialSelect (e) {
				this.currentPage = 1;
				this.getChapter();
			},
			//章节
			getChapter () {
				this.loading=true;
				this.$get("/api/teacher/get_chapter_data",{
					token: localStorage.getItem("token"),
					subject_id: this.subject_cur,
					edition_id: this.material_cur,
				})
				.then(res => {
					this.loading=false;
					this.chapter = [];
					this.chapter_cur = "";
					if (res.data.length > 0) {
						for (let i = 0; i < res.data.length; i++) {
							res.data[i].open = false;
							if (res.data[i].chapter_data.length > 0) {
								for (let j = 0; j < res.data[i].chapter_data.length; j++) {
									res.data[i].chapter_data[j].open = false;
								}
							}
						}
						this.chapter = res.data;
						res.data[0].open = true;
						if (res.data[0].chapter_data.length > 0) {
							res.data[0].chapter_data[0].open = true;
							if (this.chapter[0].chapter_data[0].section_knowledge_data.length > 0) {
								this.chapter_cur = this.chapter[0].chapter_data[0].section_knowledge_data[0].knowledgeId;
							}
						}
						if (this.chapter_cur != "") {
							this.getList();
						}
					}
				});
			},
			firstOpen (e) {
				if (this.chapter[e].open) {
					this.chapter[e].open = false;
				} else {
					this.chapter[e].open = true;
				}
			},

		
			//章节
			secondOpen (index,secondIndex) {

				if (this.chapter[index].chapter_data[secondIndex].open) {
					this.chapter[index].chapter_data[secondIndex].open = false;
				} else {
					this.chapter[index].chapter_data[secondIndex].open = true;
				}
			},
			//知识点
			secondOpen2 (index,secondIndex) {

				if (this.chapter[index].knowledge_level_two_data[secondIndex].open) {
					this.chapter[index].knowledge_level_two_data[secondIndex].open = false;
				} else {
					this.chapter[index].knowledge_level_two_data[secondIndex].open = true;
				}
			},
			knowledgeCheck (id) {
				this.chapter_cur = id;
				this.getList();
			},
			//题库
			getList () {
				this.loading=true;

				let qtype = this.qtype_cur;
				if (qtype == "全部") {
					qtype = "";
				}
				this.list = [];
				this.$get("/api/teacher/get_questions_data",{
					token: localStorage.getItem("token"),
					knowledge_id: this.chapter_cur,
					qtype: qtype,
					diff: this.diff_cur,
					subject_id: this.subject_cur,
					year: this.year_cur,
					paper_tpye: this.paper_type_cur,
					page: this.currentPage,
					limit: this.pageSize,
				})
				.then(res => {
					this.loading=false;

					if (res.data.data.length > 0) {
						for (let i = 0; i < res.data.data.length; i++) {
							res.data.data[i].select = false;
						}
					}
					this.list = res.data.data;
					this.total = res.data.total;
				});
			},
			//加入
			join (e) {
				this.$get("/api/teacher/post_not_test_add",{
					token: localStorage.getItem("token"),
					id: this.list[e].id,
				})
				.then(res => {
					this.list[e].is_join = 1;
					this.$message({
						type: 'success',
						message: res.msg,
						duration: 1500,
					});
					this.getBasket();
				});
			},
			//移除
			remove (e) {
				this.$get("/api/teacher/post_not_test_del",{
					token: localStorage.getItem("token"),
					id: this.list[e].id,
				})
				.then(res => {
					this.list[e].is_join = 0;
					this.$message({
						type: 'success',
						message: res.msg,
						duration: 1500,
					});
					this.getBasket();
				});
			},
			//展开
			select (e) {
				if (this.list[e].select) {
					this.list[e].select = false;
				} else {
					this.list[e].select = true;
				}
			},
			//试题篮
			getBasket () {
				this.$get("/api/teacher/get_not_test_data",{
					token: localStorage.getItem("token"),
					subject_id: this.subject_cur,
				})
				.then(res => {
					this.basket = res.data;
				});
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getList();
			},
				//知识点章节切换
			onChangeTab(index){
				if(index!=this.tab_active)	{
					this.currentPage = 1;
					this.tab_active=index;
						this.tab_active ? this.getChapter() : this.getKnowLedge();
						
					
					}

				
			}
		},
	}
</script>

<style scoped>
.select-wrap{
	margin-bottom: 18px;
}
.tab-wrap{
	width: 250px;
	border: 1px solid #AFA9FE;
	height: 30px;
	margin-bottom: 18px;
    box-sizing: border-box;
	border-radius: 4px;
	
}
.tab-wrap .tab-item{
	float: left;
	width: 50%;
	height: 100%;
	line-height: 30px;text-align: center;
	color: #AFA9FE;
	cursor: pointer;
}
.tab-wrap .tab-item.active{
	color: #fff;
	background: #AFA9FE;
}
</style>